import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import md5 from 'md5';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/process.home.actions';
import * as manage from '../../../../actions/api.manage.process.actions';

import Popup from './Popup';
import EditFamily from './FamilyAdd';
import EditProcess from './ProcessAdd';
import ClientsDialog from './ClientsDialog';
import Snackbar from '../../../labels/Snackbar';

import { DotsIcon, BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

import Sleep from '@material-ui/icons/NotificationsPaused';

class Index extends React.Component {
    state = {
        open: null,
        openclone: false,
        editFamily: false,
        editProcess: false,
        clone: false,
    };

    handleOpen = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleClose = (task) => (event) => {
        const { data, family } = this.props;
        if (family === undefined) {
            switch (task) {
                case 'delete':
                    this.props.manageProcessDeleteFamily(data.nombre, data.codigo);
                    this.setState({ open: null });
                    break;
                case 'edit':
                    this.setState({ open: null, editFamily: true, value: data.name });
                    break;
                default:
                    this.setState({ open: null });
                    break;
            }
        } else {
            switch (task) {
                case 'delete':
                    this.props.deleteProcess(data.nombre, data.codigo, family);
                    this.setState({ open: null });
                    break;
                case 'duplicity':
                    this.setState({ openclone: true, open: null, duplicated: true });
                    break;
                case 'clone':
                    this.setState({ openclone: true, open: null });
                    break;
                case 'edit':
                    this.setState({ open: null, editProcess: true });
                    break;
                case 'open':
                    const url = `/manage/process/${this.props.family}/${this.props.data.codigo}`;
                    this.props.setCurrentWindow(this.props.data.nombre);
                    this.props.history.push(url);
                    break;
                default:
                    this.setState({ open: null });
                    break;
            }
        }
    };

    handleCloseDialog = (client, rules, programming, programmingfields, clonarpermisos, name) => {
        const { data } = this.props;
        const { duplicated } = this.state;
        if (client) {
            this.props
                .duplicateProcess(data, name, client, rules, programming, programmingfields, clonarpermisos, duplicated)
                .then((clone) => this.setState({ clone: clone }))
                .catch((error) => this.setState({ error: error.message }));
        }
        this.setState({ openclone: false, duplicated: false });
    };

    handleCloseProcess = (event) => {
        this.setState({ editProcess: false });
    };

    handleCloseFamily = (event) => {
        this.setState({ editFamily: false });
    };

    handleCloseLabel = (event) => {
        this.setState({ error: false, clone: false });
    };

    editElementFamily = (name) => (event) => {
        const { data } = this.props;
        this.props.renameFamily(data.codigo, data.nombre, name, md5(name));
        this.setState({ editFamily: false });
    };

    editElementProcess = (value) => {
        const { data } = this.props;
        this.props.editProcess(data.codigo, value, md5(value.familia))
                  .catch((error) => { 
                        console.error(error);
                        this.setState({error: error.message, errorType: error.type}) 
                    });
        this.setState({ editProcess: false });
    };

    handleClick = (e) => {
        const url = `/manage/process/${this.props.family ? this.props.family + '/' : ''}${this.props.data.codigo}`;
        this.props.setCurrentWindow(this.props.data.nombre);
        this.props.history.push(url);
    };

    render() {
        const { editFamily, editProcess, open, openclone, error, errorType, clone, duplicated } = this.state;
        const { data, last, active, family } = this.props;

        if(this.props.family){
            console.log(data);
        }
        
        return (
            <div
                className={
                    'flex_full_row padding_left_12 ' + (active ? 'bg_bluish' : ' shadow_right_only')
                }
            >
                <div
                    className={classNames(
                        'hand flex_full_row padding_top_12 padding_bottom_12 padding_left_12  ',
                        active
                            ? last
                                ? 'activelast'
                                : 'active'
                            : last
                            ? 'noshadow'
                            : 'shadow_down_only',
                    )}
                >
                    {this.props.family
                        ?
                            <div className={'flex_full_column'}>
                                <div className={'margin_bottom_5 flex_full_row'}>
                                    <span id="process" className={'barlow_medium c_dark_grey_blue upper'}>
                                        {data.nombre}
                                    </span>
                                </div>
                            </div>
                        :
                            <div className={'flex_full_column'} onClick={this.handleClick}>
                                <div className={'margin_bottom_5 flex_full_row'}>
                                    <span id="family" className={'barlow_medium c_dark_grey_blue upper'}>
                                        {data.nombre}
                                    </span>
                                </div>
                            </div>
                    }
                    {(data.sts || data.campoSts) &&
                        <div className="flex_auto_row nowrap align_center">
                            <img 
                                alt="sts"
                                width="24"
                                src="data:image/png;base64,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"
                            />
                            {data.sts &&
                                 <span id="family" className={'barlow_regular_subtitle c_dark_grey_blue margin_left_12'}> {"p"}</span>
                            }
                            {data.campoSts &&
                                 <span id="family" className={'barlow_regular_subtitle c_dark_grey_blue margin_left_12'}> {"c"}</span>
                            }
                        </div>
                    }
                    {(data.evitarcron) &&
                        <Sleep color="secondary" className={'margin_left_12'} />
                    }
                    <div
                        className={'flex_normal_column elements_center padding_left_12 padding_right_12'}
                        onClick={this.handleOpen}
                    >
                        <DotsIcon color="primary" />
                    </div>
                    {!this.props.family &&
                        <div
                            className={'flex_normal_column elements_center'}
                            onClick={this.handleClick}
                        >
                            <BlueRightArrowIcon color="primary" />
                        </div>
                    }
                    {open && (
                        <Popup
                            open={open}
                            onClick={this.handleClose}
                            process={family !== undefined}
                            nochilds={family !== undefined || data.processes.length === 0}
                        />
                    )}
                    {editFamily && (
                        <EditFamily
                            name={data.nombre}
                            title="form_edit_family_title"
                            open={editFamily}
                            onClose={() => this.handleCloseFamily()}
                            add={this.editElementFamily}
                        />
                    )}
                    {editProcess && (
                        <EditProcess
                            {...this.props}
                            codigo={data.codigo}
                            title="form_edit_process_title"
                            open={editProcess}
                            onClose={() => this.handleCloseProcess()}
                            add={this.editElementProcess}
                            family={family}
                        />
                    )}
                    {error && (
                        <Snackbar
                            open={error}
                            variant={errorType ? errorType: "error"}
                            text={error}
                            nonavbar={true}
                            onClose={this.handleCloseLabel}
                        />
                    )}
                    {clone && (
                        <Snackbar
                            open={clone}
                            variant="success"
                            message={'clone_success_message'}
                            nonavbar={true}
                            onClose={this.handleCloseLabel}
                        />
                    )}
                    {openclone && <ClientsDialog duplicated={duplicated} onClose={this.handleCloseDialog} />}
                </div>
            </div>
        );
    }
}

Index.propTypes = {
    history: PropTypes.object.isRequired,
};
Index = withRouter(Index);

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions, manage), dispatch);
}

Index = connect(
    null,
    mapDispatchToProps,
)(Index);

export default Index;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Check.js